/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetConfirmationRequestsList200,
  ErrorInfo,
  ConfirmationRequestDetail,
  ConfirmationRequestAdd,
  ConfirmationRequestUpdate,
  BinaryFile,
  ConfirmationRequestAddFile
} from '.././model'


/**
 * 確認依頼大区分, 確認依頼小区分, 指定された制作管理IDに紐づく確認依頼一覧を取得する。

 * @summary 確認依頼一覧取得
 */
export const getConfirmationRequestsList = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetConfirmationRequestsList200>> => {
    return axios.get(
      `/confirmationRequests/list/${productionId}`,options
    );
  }


export const getGetConfirmationRequestsListQueryKey = (productionId: number,) => [`/confirmationRequests/list/${productionId}`];

    
export type GetConfirmationRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof getConfirmationRequestsList>>>
export type GetConfirmationRequestsListQueryError = AxiosError<ErrorInfo>

export const useGetConfirmationRequestsList = <TData = Awaited<ReturnType<typeof getConfirmationRequestsList>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConfirmationRequestsList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConfirmationRequestsListQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfirmationRequestsList>>> = ({ signal }) => getConfirmationRequestsList(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getConfirmationRequestsList>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作管理（確認依頼タブ）の編集ロック処理。  
制作管理編集テーブルのレコードに編集対象、編集ロックセッションID、開始日時、有効期限等を設定する。
現在ロックをしているセッションから呼ばれたときは、編集ロックの有効期限を延長する。

 * @summary 制作管理（確認依頼タブ）編集ロック
 */
export const postConfirmationRequestLock = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/confirmationRequests/lock/${productionId}`,undefined,options
    );
  }



    export type PostConfirmationRequestLockMutationResult = NonNullable<Awaited<ReturnType<typeof postConfirmationRequestLock>>>
    
    export type PostConfirmationRequestLockMutationError = AxiosError<ErrorInfo>

    export const usePostConfirmationRequestLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConfirmationRequestLock>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConfirmationRequestLock>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postConfirmationRequestLock(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postConfirmationRequestLock>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 制作管理（確認依頼タブ）の編集をキャンセルし、編集ロックを解除する。

 * @summary 制作管理（確認依頼タブ）編集キャンセル・ロック解除
 */
export const postConfirmationRequestCancel = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/confirmationRequests/cancel/${productionId}`,undefined,options
    );
  }



    export type PostConfirmationRequestCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postConfirmationRequestCancel>>>
    
    export type PostConfirmationRequestCancelMutationError = AxiosError<ErrorInfo>

    export const usePostConfirmationRequestCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConfirmationRequestCancel>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConfirmationRequestCancel>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postConfirmationRequestCancel(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postConfirmationRequestCancel>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 確認依頼を一件追加する。

 * @summary 確認依頼一件追加
 */
export const postConfirmationRequsestAdd = (
    productionId: number,
    confirmationRequestAdd: ConfirmationRequestAdd, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ConfirmationRequestDetail>> => {const formData = new FormData();
formData.append('action', confirmationRequestAdd.action.toString())
formData.append('confirmation_request_division_id', confirmationRequestAdd.confirmation_request_division_id.toString())
if(confirmationRequestAdd.title !== undefined) {
 formData.append('title', confirmationRequestAdd.title)
 }
if(confirmationRequestAdd.url !== undefined) {
 formData.append('url', confirmationRequestAdd.url)
 }
if(confirmationRequestAdd.judge !== undefined) {
 formData.append('judge', confirmationRequestAdd.judge)
 }
if(confirmationRequestAdd.due_on !== undefined) {
 formData.append('due_on', confirmationRequestAdd.due_on)
 }
if(confirmationRequestAdd.comment !== undefined) {
 formData.append('comment', confirmationRequestAdd.comment)
 }
if(confirmationRequestAdd.confirmation_user_ids !== undefined) {
 formData.append('confirmation_user_ids', confirmationRequestAdd.confirmation_user_ids)
 }
if(confirmationRequestAdd.confirmation_team_ids !== undefined) {
 formData.append('confirmation_team_ids', confirmationRequestAdd.confirmation_team_ids)
 }
if(confirmationRequestAdd['files[]'] !== undefined) {
 confirmationRequestAdd['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/confirmationRequests/add/${productionId}`,
      formData,options
    );
  }



    export type PostConfirmationRequsestAddMutationResult = NonNullable<Awaited<ReturnType<typeof postConfirmationRequsestAdd>>>
    export type PostConfirmationRequsestAddMutationBody = ConfirmationRequestAdd
    export type PostConfirmationRequsestAddMutationError = AxiosError<ErrorInfo>

    export const usePostConfirmationRequsestAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConfirmationRequsestAdd>>, TError,{productionId: number;data: ConfirmationRequestAdd}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConfirmationRequsestAdd>>, {productionId: number;data: ConfirmationRequestAdd}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postConfirmationRequsestAdd(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postConfirmationRequsestAdd>>, TError, {productionId: number;data: ConfirmationRequestAdd}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 確認依頼を更新する。

 * @summary 確認依頼一件更新
 */
export const postConfirmationRequsestUpdate = (
    confirmationRequestId: number,
    confirmationRequestUpdate: ConfirmationRequestUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ConfirmationRequestDetail>> => {const formData = new FormData();
formData.append('action', confirmationRequestUpdate.action.toString())
if(confirmationRequestUpdate.title !== undefined) {
 formData.append('title', confirmationRequestUpdate.title)
 }
if(confirmationRequestUpdate.url !== undefined) {
 formData.append('url', confirmationRequestUpdate.url)
 }
if(confirmationRequestUpdate.judge !== undefined) {
 formData.append('judge', confirmationRequestUpdate.judge)
 }
if(confirmationRequestUpdate.due_on !== undefined) {
 formData.append('due_on', confirmationRequestUpdate.due_on)
 }
if(confirmationRequestUpdate.comment !== undefined) {
 formData.append('comment', confirmationRequestUpdate.comment)
 }
if(confirmationRequestUpdate.base_history_id !== undefined) {
 formData.append('base_history_id', confirmationRequestUpdate.base_history_id.toString())
 }
if(confirmationRequestUpdate.confirmation_user_ids !== undefined) {
 formData.append('confirmation_user_ids', confirmationRequestUpdate.confirmation_user_ids)
 }
if(confirmationRequestUpdate.confirmation_team_ids !== undefined) {
 formData.append('confirmation_team_ids', confirmationRequestUpdate.confirmation_team_ids)
 }
if(confirmationRequestUpdate.file_ids !== undefined) {
 formData.append('file_ids', confirmationRequestUpdate.file_ids)
 }
if(confirmationRequestUpdate['files[]'] !== undefined) {
 confirmationRequestUpdate['files[]'].forEach(value => formData.append('files[]', value));
 }
if(confirmationRequestUpdate.save_revision !== undefined) {
 formData.append('save_revision', confirmationRequestUpdate.save_revision.toString())
 }

    return axios.post(
      `/confirmationRequests/update/${confirmationRequestId}`,
      formData,options
    );
  }



    export type PostConfirmationRequsestUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postConfirmationRequsestUpdate>>>
    export type PostConfirmationRequsestUpdateMutationBody = ConfirmationRequestUpdate
    export type PostConfirmationRequsestUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostConfirmationRequsestUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConfirmationRequsestUpdate>>, TError,{confirmationRequestId: number;data: ConfirmationRequestUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConfirmationRequsestUpdate>>, {confirmationRequestId: number;data: ConfirmationRequestUpdate}> = (props) => {
          const {confirmationRequestId,data} = props ?? {};

          return  postConfirmationRequsestUpdate(confirmationRequestId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postConfirmationRequsestUpdate>>, TError, {confirmationRequestId: number;data: ConfirmationRequestUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 確認依頼詳細データを取得する。

 * @summary 確認依頼一件取得
 */
export const getConfirmationRequestDetail = (
    confirmationRequestId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ConfirmationRequestDetail>> => {
    return axios.get(
      `/confirmationRequests/detail/${confirmationRequestId}`,options
    );
  }


export const getGetConfirmationRequestDetailQueryKey = (confirmationRequestId: number,) => [`/confirmationRequests/detail/${confirmationRequestId}`];

    
export type GetConfirmationRequestDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getConfirmationRequestDetail>>>
export type GetConfirmationRequestDetailQueryError = AxiosError<ErrorInfo>

export const useGetConfirmationRequestDetail = <TData = Awaited<ReturnType<typeof getConfirmationRequestDetail>>, TError = AxiosError<ErrorInfo>>(
 confirmationRequestId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConfirmationRequestDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConfirmationRequestDetailQueryKey(confirmationRequestId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfirmationRequestDetail>>> = ({ signal }) => getConfirmationRequestDetail(confirmationRequestId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getConfirmationRequestDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(confirmationRequestId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 確認依頼添付ファイルを取得する。

 * @summary 確認依頼添付ファイル取得
 */
export const getConfirmationRequestAttachedFile = (
    fileId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/confirmationRequests/attachedFile/${fileId}`,options
    );
  }


export const getGetConfirmationRequestAttachedFileQueryKey = (fileId: number,) => [`/confirmationRequests/attachedFile/${fileId}`];

    
export type GetConfirmationRequestAttachedFileQueryResult = NonNullable<Awaited<ReturnType<typeof getConfirmationRequestAttachedFile>>>
export type GetConfirmationRequestAttachedFileQueryError = AxiosError<ErrorInfo>

export const useGetConfirmationRequestAttachedFile = <TData = Awaited<ReturnType<typeof getConfirmationRequestAttachedFile>>, TError = AxiosError<ErrorInfo>>(
 fileId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConfirmationRequestAttachedFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConfirmationRequestAttachedFileQueryKey(fileId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfirmationRequestAttachedFile>>> = ({ signal }) => getConfirmationRequestAttachedFile(fileId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getConfirmationRequestAttachedFile>>, TError, TData>(queryKey, queryFn, {enabled: !!(fileId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 確認依頼ファイル追加アップロード。

 * @summary 確認依頼ファイル追加アップロード
 */
export const getConfirmationRequestAddFile = (
    confirmationRequestHistoryId: number,
    confirmationRequestAddFile: ConfirmationRequestAddFile, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(confirmationRequestAddFile['files[]'] !== undefined) {
 confirmationRequestAddFile['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/confirmationRequests/addFile/${confirmationRequestHistoryId}`,
      formData,options
    );
  }



    export type GetConfirmationRequestAddFileMutationResult = NonNullable<Awaited<ReturnType<typeof getConfirmationRequestAddFile>>>
    export type GetConfirmationRequestAddFileMutationBody = ConfirmationRequestAddFile
    export type GetConfirmationRequestAddFileMutationError = AxiosError<ErrorInfo>

    export const useGetConfirmationRequestAddFile = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfirmationRequestAddFile>>, TError,{confirmationRequestHistoryId: number;data: ConfirmationRequestAddFile}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConfirmationRequestAddFile>>, {confirmationRequestHistoryId: number;data: ConfirmationRequestAddFile}> = (props) => {
          const {confirmationRequestHistoryId,data} = props ?? {};

          return  getConfirmationRequestAddFile(confirmationRequestHistoryId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof getConfirmationRequestAddFile>>, TError, {confirmationRequestHistoryId: number;data: ConfirmationRequestAddFile}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 確認依頼添付ファイルを削除する。

 * @summary 確認依頼添付ファイル削除
 */
export const getConfirmationRequestDeleteFile = (
    fileId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/confirmationRequests/deleteFile/${fileId}`,undefined,options
    );
  }



    export type GetConfirmationRequestDeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof getConfirmationRequestDeleteFile>>>
    
    export type GetConfirmationRequestDeleteFileMutationError = AxiosError<ErrorInfo>

    export const useGetConfirmationRequestDeleteFile = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfirmationRequestDeleteFile>>, TError,{fileId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConfirmationRequestDeleteFile>>, {fileId: number}> = (props) => {
          const {fileId} = props ?? {};

          return  getConfirmationRequestDeleteFile(fileId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof getConfirmationRequestDeleteFile>>, TError, {fileId: number}, TContext>(mutationFn, mutationOptions)
    }
    